export const logIn = {
    "formType": 'logIn',
    "idetifier":[
        "email",
        "password"
    ],
    "title": 'Вхід',
    "dataType": 'logIn',
    "fields": [
        {
            "legend": 'E-mail',
            "id":1,
            "type": 'email',
            "name":'email',
            "required": true,
            "options": false,
            "props": [
                {
                    "label": '',
                    "type": 'email',
                    "placeholder": 'example@gmail.com'
                }
            ]
        },
        {
            "legend": "Пароль",
            "id":2,
            "type": 'password',
            "name": 'password',
            "required": true,
            "options": false,
            "props": [
                {
                    "label": '',
                    "type": 'password',
                    "placeholder": 'Введіть свій пароль'
                }
            ]
        }
    ],
    "button": 'Увійти',
    "class": 'form__box__login'
}